import type { ReactNode } from "react";
import { toast } from "sonner";

import {
  useDescartarRegistroDeTerreno,
  useRestaurarRegistroDeTerreno,
} from "@/hooks/usePapeleraDeTerreno";
import { useRegistroDeTerreno } from "@/hooks/useRegistroDeTerreno";

import { DescarteDeTerrenoContext } from "./contextoDeDescarte";

/**
 * Provee «Descartar» a TODO lo que dibuja registros de terreno: la pestaña
 * «Registro de terreno» y los paneles de las pestañas técnicas. Va UNA vez, en
 * un ancestro común (el editor del informe), y no un proveedor por panel.
 *
 * Sin permiso (`puede_descartar` falso: no es el ejecutivo del informe ni
 * Super Admin) o sin registro cargado el contexto queda en `null` y ningún
 * botón se dibuja. Descartar se deshace, así que no pide confirmación: avisa y
 * ofrece «Deshacer».
 */
export function ProveedorDeDescarteDeTerreno({
  informeId,
  habilitado = true,
  children,
}: {
  informeId: number;
  /** Falso cuando el informe no admite el registro de terreno: no se consulta nada. */
  habilitado?: boolean;
  children: ReactNode;
}) {
  // La misma consulta que la barra y la pestaña: no pide nada nuevo.
  const registro = useRegistroDeTerreno(habilitado ? informeId : null);
  const descartarBloque = useDescartarRegistroDeTerreno(informeId);
  const restaurarBloque = useRestaurarRegistroDeTerreno(informeId);

  const descartar = (uuid: string) =>
    descartarBloque.mutate(uuid, {
      onSuccess: () =>
        toast("Descartado. Lo encuentras en la papelera.", {
          action: { label: "Deshacer", onClick: () => restaurarBloque.mutate(uuid) },
        }),
      onError: () => toast.error("No se pudo descartar. Inténtalo de nuevo."),
    });

  return (
    <DescarteDeTerrenoContext.Provider value={registro.data?.puede_descartar ? descartar : null}>
      {children}
    </DescarteDeTerrenoContext.Provider>
  );
}
